import { motion } from 'framer-motion';
import { missions } from '../data/missions';
import type { MissionId } from '../data/missions';
import { useLanguage } from '../i18n/LanguageContext';
import { copy } from '../i18n/copy';
import MissionCard from './MissionCard';
import MissionDetailPanel from './MissionDetailPanel';

interface MissionSelectorProps {
  selected: MissionId;
  onSelect: (id: MissionId) => void;
}

export default function MissionSelector({ selected, onSelect }: MissionSelectorProps) {
  const { t } = useLanguage();
  const selectedMission = missions.find((m) => m.id === selected) ?? missions[0];

  return (
    <section id="missions" className="relative mx-auto max-w-6xl scroll-mt-24 px-5 py-16">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.5 }}
        className="text-center"
      >
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-cyan-300/80">
          {t(copy.missionsKicker)}
        </p>
        <h2 className="mt-3 text-3xl font-extrabold text-white md:text-4xl">
          {t(copy.missionsTitle)}
        </h2>
      </motion.div>

      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {missions.map((mission) => (
          <MissionCard
            key={mission.id}
            mission={mission}
            selected={selected === mission.id}
            onSelect={() => onSelect(mission.id)}
          />
        ))}
      </div>

      <MissionDetailPanel mission={selectedMission} />
    </section>
  );
}
